import React from 'react';
import { Heading } from 'js/design_system/Heading';
import { Body } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { Icon } from 'js/design_system/Icon';

interface PreprintUploadStepProps {
  onGoToStep2?: () => void;
}

export const PreprintUploadStep: React.FC<PreprintUploadStepProps> = ({
  onGoToStep2,
}) => (
  <div style={{ textAlign: 'center', padding: '48px 0' }}>
    <Icon name="check_circle" size={40} />
    <Heading size="md" as="h2" style={{ marginTop: '16px' }}>
      Your preprint has been uploaded
    </Heading>
    <Body
      size="md"
      style={{ color: 'var(--text-secondary)', marginTop: '8px' }}
    >
      Click{' '}
      {onGoToStep2 ? (
        <BodyLink
          underline
          style={{ color: 'var(--text-link)' }}
          onClick={onGoToStep2}
        >
          Next
        </BodyLink>
      ) : (
        'Next'
      )}{' '}
      to review your reference report.
    </Body>
  </div>
);

export default PreprintUploadStep;
